import React from 'react';
// internal
import AboutMeTestimonial from 'components/testimonials/about-me-testimonial';
import PortfolioService from 'components/services/portfolio-service';
import PortfolioSkills from 'components/skills/portfolio-skills';
import AgencyBrands from 'components/brands/agency-brands';
import AboutCta from 'components/cta/about-cta';
import AboutMeBreadcrumb from './about-me-breadcrumb';
import AboutMeInfo from './about-me-info';
import AboutMePortfolio from './about-me-portfolio';

// About Page Iconsnpm i @emailjs/browser --legacy-peer-deps

import icon1 from "assets/img/Main Images/About/company-icon-1.png"
import icon2 from "assets/img/Main Images/About/company-icon-2.png"
import icon3 from "assets/img/Main Images/About/company-icon-3.png"
import icon4 from "assets/img/Main Images/About/company-icon-4.png"

const data = [
  {
    icon: icon1,
    image: true,
    title: " Innovation First:",
    designation:
      "We embrace emerging technologies and creative thinking to build innovative digital experiences that help businesses stay ahead in a rapidly evolving world.",
    // year: "April 2020 - Present",
  },
  {
    icon: icon2,
    image: true,
    title: " Quality Without Compromise:",
    designation:
      "From design and development to deployment, every project is crafted with precision, performance, and attention to detail to deliver exceptional results.",
    // year: "April 2016 - March 2020",
  },
  {
    icon: icon3,
    image: true,
    title: "Client-Centric Approach:",
    designation:
      "We work closely with our clients, understanding their goals and challenges to create tailored solutions that deliver measurable business value.",
    // year: "April 2012 - March 2016",
  },
  {
    icon: icon4,
    image: true,
    title: "Collaboration & Growth",
    designation:
      "Great ideas come from strong partnerships. We foster collaboration, transparency, and continuous learning to build lasting relationships and achieve shared success.",
    // year: "April 2008 - March 2012",
  },
];

const AboutMeArea = () => {
  return (
    <React.Fragment>
      <AboutMeBreadcrumb />
      <AboutMeInfo />
      {/* <PortfolioService style_2={true} /> */}
      <PortfolioSkills data={data} />
      {/* <AboutMePortfolio/> */}
      {/* <AgencyBrands spacing={true} style_2={true} /> */}
      <AboutMeTestimonial />
      {/* <AboutCta/> */}
    </React.Fragment>
  );
};

export default AboutMeArea;